<template>
  <main>
    <Hero/>
    <Features/>
    <ContentWithImage sectionName="volume-of-content" class="volume-of-content" text-size="sm" justify-center image-order="1" image-order-sm="0" image-margin="auto 0 auto -20px" h2/>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_keep-on-top'" ext="png">
      <div class="keep-on-top">
        <ContentWithImage sectionName="keep-on-top-of-changes" text-size="sm" justify-center image-order="0" image-order-sm="2" h2 margin="0"/>
      </div>
    </background-wrapper>
    <ContentWithImage sectionName="access-helpful-videos" text-size="sm" justify-center image-order="1" image-order-sm="0" h2/>
    <ContentWithImage sectionName="hr-director" text-size="sm" justify-center image-order="0" image-order-sm="0" image-margin="auto -20px auto 0px" h2/>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_hr-drive-included'" ext="png">
      <text-container class="hr-drive-included" size="lg" align-center justify-center>
        <img class="product-icon mb-3" :src="require(`@/assets/drive/drive-icon.png`)"/>
        <h2 v-html="$t(`products.${$route.name}.hr-drive-included.title`)"/>
        <p v-html="$t(`products.${$route.name}.hr-drive-included.text`)"/>
        <b-btn class="mt-2" variant="primary" v-scroll-to="{ el: '#request-a-demo', offset: -70 }">
          {{$t(`learn-more`)}}
        </b-btn>
        <img class="hr-drive-included__image mt-5" :src="require(`@/assets/${routeNameKebab}/hr-drive-included.png`)" width="576px"/>
      </text-container>
    </background-wrapper>
    <RequestDemo/>
    <Tools/>
    <LetsGet/>
  </main>
</template>

<script>
import { Hero, Tools, LetsGet, ContentWithImage, RequestDemo, Features } from '@/components/ui/products'
export default {
  name: 'Fundamentals',
  components: { Hero, Tools, LetsGet, ContentWithImage, RequestDemo, Features },
  computed: {
    routeNameKebab: app => app.$toKebabCase(app.$route.name)
  }
}
</script>

<style lang="sass" scoped>
.volume-of-content
  +media-breakpoint-down(sm)
    margin-bottom: 215px!important

.keep-on-top
  padding-bottom: 520px
  +media-breakpoint-down(lg)
    padding-bottom: 320px
  +media-breakpoint-down(sm)
    padding-bottom: 180px
  +media-breakpoint-down(xs)
    margin-top: -20px
    padding-top: 20px
    padding-bottom: 200px

.product-icon
  width: 100px

.hr-drive-included
  margin-bottom: 400px
  +media-breakpoint-down(sm)
    padding: 100px 45px 0 45px
    margin-top: -100px
    margin-bottom: 400px

  &__image
    margin-bottom: -250px
    +media-breakpoint-down(sm)
      margin-bottom: -250px
    +media-breakpoint-down(xs)
     width: 100%
</style>



// WEBPACK FOOTER //
// src/components/products/Fundamentals/Fundamentals.vue